var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Base',[_c('Title',[_vm._v(_vm._s(_vm.$slots.default[0].text))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }